module.exports = __webpack_public_path__ + "media/images/ui-bg_flat_75_ffffff_40x100-842c345c1938a3845ab565b3d5e7445d.png";